import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LstAuthService } from '@savvaslearning/lst-auth';
import { Observable } from 'rxjs';
import { StorageService } from '../../services/storage-service/storage.service';
import { PROFILE_TOKEN } from '../store/multi-stage-assignment-report.model';
import { MultiStageAuthService } from './multi-stage-auth.service';

@Injectable({
    providedIn: 'root',
})
export class MultiStageAuthGuard implements CanActivate {
    constructor(
        private readonly lstAuthService: LstAuthService,
        private readonly multiStageAuthService: MultiStageAuthService,
        private readonly storageService: StorageService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const rbsToken = this.multiStageAuthService.getRbsToken() || this.storageService.getItem(PROFILE_TOKEN);
        if (rbsToken) {
            this.storageService.setItem(PROFILE_TOKEN, rbsToken);
            return this.lstAuthService.verifySession(state.url);
        } else {
            return this.lstAuthService.redirectToSSOLoginPage(state.url);
        }
    }
}
